import { render, staticRenderFns } from "./GoodsCategoryList.vue?vue&type=template&id=10b1cd2f&scoped=true&"
import script from "./GoodsCategoryList.vue?vue&type=script&lang=js&"
export * from "./GoodsCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1cd2f",
  null
  
)

export default component.exports